(function () {
  var bar = document.getElementById('nc-vbar');
  if (!bar) return;
  var KEY = ncVehicle.KEY, DISMISS = 'nc_vbar_dismissed';
  var API = ncVehicle.API;
  var T = window.NC_I18N.vehicleBar;
  var make = document.getElementById('nc-vbar-make'),
      model = document.getElementById('nc-vbar-model'),
      type = document.getElementById('nc-vbar-type'),
      save = document.getElementById('nc-vbar-save'),
      pending = null,
      toast = document.getElementById('nc-vbar-toast'),
      loaded = false;
  if (!make || !model || !type || !save || !toast) return;

  function hasCar() {
    var c = ncVehicle.load(); return !!(c && (c.typeId || c.modelHandle || c.makeName));
  }
  function dismissed() { try { return !!sessionStorage.getItem(DISMISS); } catch (e) { return false; } }
  function render() {
    var show = !hasCar() && !dismissed();
    bar.hidden = !show;
    document.documentElement.classList.toggle('nc-has-car', hasCar());
    document.documentElement.classList.toggle('nc-vbar-off', dismissed());
    if (show && !loaded) { loaded = true; load('/makes', make, T.make); }
    // Mobil: baren står altid åben (CSS); hold aria-expanded i trit
    if (show && window.matchMedia('(max-width: 749px)').matches) { bar.classList.add('nc-vbar--open'); document.getElementById('nc-vbar-toggle').setAttribute('aria-expanded', 'true'); }
  }
  // _req drops answers that arrive after a newer load/reset of the same select
  // Bilen gemmes først på knappen "Gem køretøj"; valgene stiller den kun klar
  function ready(car) { pending = car; save.disabled = !car; }
  function reset(sel, ph, disabled) { ready(null); sel._req = (sel._req || 0) + 1; sel.innerHTML = '<option value="">' + ph + '</option>'; sel.disabled = disabled; }
  // The makes list is the same on every page; cache it per session so each page view doesn't hit the API
  function fetchCached(path) {
    var key = 'nc_vapi:' + path, cached = null;
    if (path === '/makes') { try { cached = JSON.parse(sessionStorage.getItem(key)); } catch (e) {} }
    if (cached) return Promise.resolve(cached);
    return fetch(API + path).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); }).then(function (d) {
      if (path === '/makes') { try { sessionStorage.setItem(key, JSON.stringify(d)); } catch (e) {} }
      return d;
    });
  }
  function load(path, sel, ph) {
    sel.disabled = true;
    var req = sel._req = (sel._req || 0) + 1;
    return fetchCached(path).then(function (d) {
      if (req !== sel._req) return;
      var list = d.makes || d.models || d.types || d;
      list = path === '/makes' ? ncVehicle.byName(list) : ncVehicle.withParts(list);
      reset(sel, ph, false);
      list.forEach(function (m) {
        var o = document.createElement('option');
        o.value = m.id || m.makeId || m.modelId || m.typeId || m.slug || m.name;
        o.textContent = ncVehicle.typeLabel(m.name);
        o.dataset.name = o.textContent;
        o.dataset.handle = m.collectionHandle || m.handle || '';
        o.dataset.productCount = String(m.product_count || 0);
        o.dataset.hasVariants = m.hasVariants ? '1' : '0';
        sel.appendChild(o);
      });
    }).catch(function () { if (req === sel._req) sel.disabled = false; });
  }
  // Bilen kan gemmes på hvert trin: mærke (BMW), model (BMW 3-Serie) eller variant — jo flere trin, jo smallere filter.
  function makeCar() {
    var k = make.options[make.selectedIndex];
    return ncVehicle.car({ makeId: make.value, makeName: k.dataset.name || k.textContent });
  }
  function modelCar() {
    var m = model.options[model.selectedIndex];
    return ncVehicle.car({ makeId: make.value, makeName: makeCar().makeName, modelId: model.value, modelName: m.dataset.name || m.textContent,
      modelHandle: m.dataset.handle, productCount: parseInt(m.dataset.productCount, 10) || 0 });
  }
  make.addEventListener('change', function () {
    reset(type, T.type, true);
    if (!make.value) return reset(model, T.model, true);
    load('/models?makeId=' + encodeURIComponent(make.value), model, T.model).then(function () { if (make.value) ready(makeCar()); });
  });
  model.addEventListener('change', function () {
    reset(type, T.type, true);
    if (!model.value) return ready(makeCar());
    var m = model.options[model.selectedIndex];
    if (m.dataset.handle) ready(modelCar());
    // Modeller uden varianter: modelvalget er det endelige valg.
    if (m.dataset.hasVariants !== '1' && m.dataset.handle) return;
    load('/types?makeId=' + encodeURIComponent(make.value) + '&modelId=' + encodeURIComponent(model.value), type, T.type).then(function () { if (model.value && m.dataset.handle) ready(modelCar()); });
  });
  type.addEventListener('change', function () {
    var t = type.options[type.selectedIndex], m = model.options[model.selectedIndex], k = make.options[make.selectedIndex];
    if (!t || !t.value || !m.dataset.handle || !t.dataset.handle) return ready(m && m.dataset.handle ? modelCar() : makeCar());
    ready(ncVehicle.car({
      makeId: make.value, makeName: k.dataset.name || k.textContent, modelId: model.value, modelName: m.dataset.name || m.textContent,
      modelHandle: m.dataset.handle, typeId: t.value, typeHandle: t.dataset.handle, typeName: t.textContent,
      productCount: parseInt(t.dataset.productCount, 10) || 0
    }));
  });
  save.addEventListener('click', function () { if (pending) commit(pending); });
  function commit(car) {
    var r = save.getBoundingClientRect();
    if (!ncVehicle.save(car)) return;
    document.dispatchEvent(new CustomEvent('nc:car-saved', { detail: car }));
    // Kun sider der faktisk filtrerer på bilen viser "Viser nu dele til"; typesense-search-brands-v9.js
    // sætter ncGarageFilters med samme undtagelser som sit eget filter.
    // Mærke-niveau har ingen bil-kollektion: søgesiden rangerer mærkets dele først.
    var t = { name: car.typeName, filtered: !!window.ncGarageFilters, href: ncVehicle.carUrl(car) };
    // Collection/søg læser bilen ved indlæsning → genindlæs; andre sider bliver hvor de er
    // Bilside: gå til den nye bils side (siden selv er låst til sin bil).
    if (ncVehicle.onCarPage()) {
      try { sessionStorage.setItem('nc_garage_pulse', '1'); } catch (e) {}
      location.href = t.href;
    } else if (/^\/(collections|search)(\/|$)/.test(ncVehicle.localPath(location.pathname))) {
      try { sessionStorage.setItem('nc_vbar_toast', JSON.stringify(t)); } catch (e) {}
      try { sessionStorage.setItem('nc_garage_pulse', '1'); } catch (e) {}
      location.reload();
    } else {
      showToast(t);
      document.dispatchEvent(new CustomEvent('nc:car-added', { detail: { fromRect: r } }));
    }
  }
  function showToast(t) {
    toast.textContent = (t.filtered ? T.showing : T.saved) + ' ' + t.name;
    // Ufiltreret side: gemt, ikke navigeret — tilbyd vejen til bilens dele som et separat link
    if (!t.filtered && t.href) {
      var a = document.createElement('a');
      a.href = t.href;
      a.className = 'nc-vbar-toast__link';
      a.textContent = T.seeParts;
      toast.appendChild(document.createTextNode(' '));
      toast.appendChild(a);
    }
    toast.hidden = false;
    setTimeout(function () { toast.hidden = true; }, t.filtered ? 4000 : 8000);
  }
  document.getElementById('nc-vbar-close').addEventListener('click', function () {
    try { sessionStorage.setItem(DISMISS, '1'); } catch (e) {}
    render();
  });
  document.getElementById('nc-vbar-toggle').addEventListener('click', function () {
    var open = bar.classList.toggle('nc-vbar--open');
    this.setAttribute('aria-expanded', open);
  });
  // Header-knappen "Vælg din bil" fører til baren, mens den er synlig (ét tydeligt sted at starte)
  var gbtn = document.getElementById('nc-garage-btn');
  if (gbtn) gbtn.addEventListener('click', function (e) {
    if (bar.hidden || getComputedStyle(bar).display === 'none') return;
    e.stopImmediatePropagation();
    if (window.matchMedia('(max-width: 749px)').matches && !bar.classList.contains('nc-vbar--open')) document.getElementById('nc-vbar-toggle').click();
    bar.scrollIntoView({ behavior: 'smooth', block: 'center' });
    make.focus({ preventScroll: true });
  }, true);
  document.addEventListener('nc:car-saved', render);
  document.addEventListener('nc:car-cleared', function () { try { sessionStorage.removeItem(DISMISS); } catch (e) {} render(); });
  window.addEventListener('storage', function (e) { if (e.key === KEY) render(); });
  try {
    var queued = sessionStorage.getItem('nc_vbar_toast');
    if (queued) { sessionStorage.removeItem('nc_vbar_toast'); showToast(JSON.parse(queued)); }
  } catch (e) {}
  render();
})();
